import { Volume2 } from "lucide-react";
import { TTS_VOICES } from "@/lib/voices";

/**
 * Compact narration-voice selector. Lets users pick a male/female/neutral
 * voice (and a British-leaning option) for spoken Ask ERIO answers.
 */
export const VoicePicker = ({ value, onChange, testid, dark = false }) => (
  <label className="flex items-center gap-1" title="Narration voice">
    <Volume2 size={13} className={dark ? "text-white/60" : "text-ek-ink/65"} />
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testid}
      onClick={(e) => e.stopPropagation()}
      className={`max-w-[10.5rem] cursor-pointer rounded-md border bg-transparent py-0.5 pl-1 pr-5 text-[11px] font-semibold outline-none ${
        dark
          ? "border-white/20 text-white/80 [&>option]:text-ek-ink"
          : "border-black/10 text-ek-ink/60"
      }`}
    >
      {TTS_VOICES.map((v) => (
        <option key={v.id} value={v.id}>{v.label}</option>
      ))}
    </select>
  </label>
);
